import React from 'react';


export default function DetailScreenWrapper({
  children
}:{
  children: React.ReactNode
}){

  return (
    <div 
      id="mm-detail-screens" 
      className="mm-section"
      style={{ width: "700px", display: "flex", flexWrap: "nowrap", flexDirection: "column", position: "relative", padding: "auto 0.75rem auto 0" }}
    >
      { children }
    </div>
  )
}